import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const MultipleRoomsBookingContentFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};

  ${mediaQueryUp.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }
`

export default MultipleRoomsBookingContentFooter
